import type { Product } from '../../../types/product';
import type { ActivityFilters } from '../../activity/types';

export const ProductSelectionMode = {
  PRODUCT_VIEW: 'PRODUCT_VIEW',
  SINGLE_PRODUCT_SELECTION: 'SINGLE_PRODUCT_SELECTION',
  MULTIPLE_PRODUCT_SELECTION: 'MULTIPLE_PRODUCT_SELECTION',
} as const;

export type ProductSelectionMode = typeof ProductSelectionMode[keyof typeof ProductSelectionMode];

// Sentinel for "no cap" consumers of MULTIPLE_PRODUCT_SELECTION (e.g. catalog line items),
// as opposed to the Activity-filter default of 5.
export const UNLIMITED_PRODUCT_SELECTION = Number.MAX_SAFE_INTEGER;

export const isProductView = (mode: ProductSelectionMode): boolean => 
  mode === ProductSelectionMode.PRODUCT_VIEW;

export const isSingleProductSelection = (mode: ProductSelectionMode): boolean => 
  mode === ProductSelectionMode.SINGLE_PRODUCT_SELECTION;

export const isMultipleProductSelection = (mode: ProductSelectionMode): boolean => 
  mode === ProductSelectionMode.MULTIPLE_PRODUCT_SELECTION;

export const isSelectionMode = (mode: ProductSelectionMode): boolean => 
  isSingleProductSelection(mode) || isMultipleProductSelection(mode);

export interface ProductSelectionContext {
  mode: ProductSelectionMode;
  activityFeId?: string;
  currentProductId?: number;
  returnPath?: string;
  // Спільний об'єкт фільтрів активностей
  activityFilters?: ActivityFilters;
  // Опційні налаштування вибору для не-Activity споживачів (наприклад, каталогу):
  // без значення — поведінка як для Activity-фільтрів (ліміт 5, стандартний напис)
  maxSelection?: number;
  infoText?: string;
  showSelectAll?: boolean;
}

export interface ProductSelectionResult {
  selectedProduct?: Product;
  selectedProducts?: Product[];
  activityFeId?: string;
}
